/* eslint-disable */
import React from 'react';

function NotFound() {
    return (
        <div className='mt-5 bt-5'>
              <div id="notfound">
        <div className="notfound text-center">
            <div className="notfound-404">
                 <img
                        src={`/images/StoreNotFound.png`}
                        className="img-pro"
                        alt=""
                      />
                      <h1>Error 404</h1>
            </div>
            <h2>We are sorry NotFound !</h2>
            <p>
                The page you are looking for might have been removed had its name changed or is temporarily unavailable.
            </p>
            			{/* <a href="#">Back To Homepage</a> */}
        </div>
    </div>        </div>
    )
}

export default NotFound